import { useTranslation } from '@thoughtspot/i18n';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { strings } from '@thoughtspot/translations';
import React, { Fragment, useEffect, useState } from 'react';
import { useGetPrivilegeGroupsQuery } from "../../../../services/role/role-service";
import { useGetGroupDetailsByIdLazyQuery } from "../../../../services/user-group/user-group-service";
import { TranslationsKeys } from '../util';
import styles from './view-privilege-modal.module.scss';
export const ViewPrivilegeModal = ({ closeModal, id = '', }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [preSelectedPrivilegeIds, setPreSelectedPrivilegeIds] = useState(null);
    const [hasAdminPrivileges, setHasAdminPrivileges] = useState(false);
    const { data: privilegesList, error: privilegesListError, loading: privilegesListLoading, refetch: refreshPrivilegesList, } = useGetPrivilegeGroupsQuery();
    const { data: groupByIdData, error: groupByIdError, loading: groupByIdLoading, getGroupById, } = useGetGroupDetailsByIdLazyQuery([id], id);
    useEffect(() => {
        if (groupByIdData) {
            const groupPrivileges = groupByIdData.getGroupDetailsById[0]?.granularPrivileges;
            setPreSelectedPrivilegeIds(groupPrivileges);
            const adminPrivilegeEnum = TranslationsKeys.ADMINISTRATION;
            setHasAdminPrivileges(groupPrivileges.includes(adminPrivilegeEnum));
        }
    }, [groupByIdData, groupByIdLoading]);
    useEffect(() => {
        if (id) {
            getGroupById();
        }
    }, [id]);
    const onDismissModal = () => {
        setIsModalOpen(false);
        closeModal();
    };
    const modalProps = {
        size: ModalSize.SMALL,
        title: t(TranslationsKeys.ALL_PRIVILEGES),
        onDismiss: onDismissModal,
        isOpen: isModalOpen,
        confirmButton: {
            text: t(TranslationsKeys.DONE),
            onConfirm: () => {
                closeModal();
            },
        },
        className: styles.modalProps,
        autoScrollContent: true,
        contentClassName: styles.modalContentClassName,
        customHeaderClassName: styles.customHeader,
        customFooterClassName: styles.customFooter,
    };
    const renderItemForReviewPrivilege = (privilege) => (React.createElement(Horizontal, { key: privilege },
        React.createElement(Typography, { variant: "body-large", overrideTag: "div", color: Colors.grayLight, className: styles.privilegeItem }, strings.tennablePrivilegesLabels[privilege])));
    const getAllPrivileges = () => {
        return privilegesList?.Data?.flatMap(group => group.privileges) || [];
    };
    const renderPrivileges = () => {
        const privilegesToRender = hasAdminPrivileges
            ? getAllPrivileges()
            : preSelectedPrivilegeIds;
        return (privilegesList?.Data?.map((record) => {
            const groupPrivileges = record.privileges.filter(function (privilege) {
                return privilegesToRender.includes(privilege);
            });
            return (React.createElement(Fragment, { key: record.groupName }, groupPrivileges?.length > 0 && (React.createElement(Vertical, { className: styles.privilegeGroupContainer },
                React.createElement(Vertical, null,
                    React.createElement(Typography, { variant: "section-label", overrideTag: "div", className: styles.privilegeGroupHeader }, strings.tennablePrivilegesLabels[record.groupName])),
                React.createElement(Vertical, { className: styles.privilegeItemContainer }, groupPrivileges?.map((item) => renderItemForReviewPrivilege(item)))))));
        }) || null);
    };
    const privilegeToShow = () => {
        const privilegesToCheck = hasAdminPrivileges
            ? getAllPrivileges()
            : preSelectedPrivilegeIds;
        const privilegeSet = new Set(privilegesToCheck);
        return privilegesList?.Data.some((record) => record.privileges.some((privilege) => privilegeSet.has(privilege)));
    };
    return (React.createElement(React.Fragment, null, privilegesList && preSelectedPrivilegeIds && (React.createElement(Modal, { ...modalProps }, privilegeToShow() ? (React.createElement(Vertical, { hAlignContent: "stretch", grow: true, className: styles.container },
        React.createElement("div", { "data-testid": "rolesModal_view" },
            React.createElement(Vertical, { className: styles.mainContainer }, renderPrivileges())))) : (React.createElement(Typography, { variant: "section-label", overrideTag: "div", className: styles.noRolesSelcted, "data-testid": "rolesModal_empty" }, t(TranslationsKeys.NO_ROLES_SELECTED)))))));
};
//# sourceMappingURL=view-privilege-modal.container.js.map